module.exports = __webpack_public_path__ + "static/media/biteship-jd.ae2b67a6.png";